import Container from './SubmitButton.container';
import SubmitButton from './SubmitButton';

export default Container(SubmitButton);
